import { FC } from 'react'
import { TrophyCard } from '~/components/TrophyCard/TrophyCard'
import styles from './TrophyGallery.module.scss'
import { ComponentTrophyDto } from '~/modules/Products/Infrastructure/Dtos/ComponentTrophyDto'

interface Props {
  trophies: ComponentTrophyDto[]
  appearance?: 'default' | 'gallery' | 'museumGallery'
}
export const TrophyGallery: FC<Props> = ({ trophies, appearance = 'default' }) => {
  const isMuseumGalleryAppearance = appearance === 'museumGallery'

  return (
    <div
      className={ `
        ${styles.trophyGallery__container}
        ${isMuseumGalleryAppearance ? styles.trophyGallery__container_museumGallery : ''}
      ` }
    >
      {
        trophies.map((trophy) => (
          <TrophyCard
            trophyDto={ trophy }
            key={ trophy.id }
            appearance={ appearance }
          />
        ))
      }
    </div>
  )
}
